import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Participant_ParticipantForOnBoardingDto,
} from '../../services/wealthlane-customer-services';

const useGetParticipantOnBoarding = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_Participant_ParticipantForOnBoardingDto | undefined,
  unknown
> => {
  const participantOnBoarding = useQuery(['getParticipantOnBoarding'], async () => {
    return await handleRequest(
      ParticipantSharedService.getApiCustomerApiAppParticipantParticipantForOnboarding()
    );
  });

  return participantOnBoarding;
};

export default useGetParticipantOnBoarding;
